import { FC } from "react";
import { useNavigate } from "react-router-dom";
import adminNavigation from "@/config/navigation/admin-navigation.json";
import * as Icons from "lucide-react";

export interface AdminNavigationItem {
  id: string | number;
  icon: FC<{ className?: string }>;
  label: string;
  route: string;
  section: string;
}

export interface AdminNavigationSection {
  title: string;
  items: AdminNavigationItem[];
}

export function useAdminNavigation() {
  const navigate = useNavigate();

  // Group navigation items by section
  const navigationSections: Record<string, AdminNavigationSection> = {
    main: { title: "Main", items: [] },
    management: { title: "Management", items: [] },
    content: { title: "Content", items: [] },
    system: { title: "System", items: [] },
  };

  // Populate sections with items from admin-navigation.json
  Object.entries(adminNavigation).forEach(([id, config]: [string, any]) => {
    const section = config.section || "main";
    if (navigationSections[section]) {
      const IconComponent = Icons[config.icon as keyof typeof Icons] as FC<{
        className?: string;
      }>;

      navigationSections[section].items.push({
        id: Number(id),
        icon: IconComponent,
        label: config.label,
        route: config.route,
        section,
      });
    }
  });

  // Navigation handler
  const navigateTo = (route: string) => {
    navigate(route);
  };

  return {
    navigationSections,
    navigateTo,
  };
}

export default useAdminNavigation;
